(function() {
  var IrrigationDetailsBase,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  IrrigationDetailsBase = App.loadClass('grower::Angular/IrrigationDetailsBase');

  exports.IrrigationDetailsController = (function(superClass) {
    extend(IrrigationDetailsController, superClass);

    function IrrigationDetailsController(scope, transitions, transition$, modalInstance, service, q, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.transition$ = transition$;
      this.modalInstance = modalInstance;
      this.service = service;
      this.q = q;
      this.ngModal = ngModal;
      this.save = bind(this.save, this);
      this.copy = bind(this.copy, this);
      IrrigationDetailsController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = "Irrigation Details";
      this.scope.validation = this.validate;
      this.scope.copy = this.copy;
      this.scope.copyDisabled = false;
      this.scope.save = this.save;
      this.scope.details = {
        layers_management_zone_id: this.transition$.params().layer_id,
        irrigation_method_id: null,
        energy_source: null,
        pump_pressure: null,
        pumping_depth: null,
        water_source_id: null,
        secondary_irrigation: false,
        secondary_use_pumps: null,
        secondary_energy_source: null,
        secondary_pump_pressure: null,
        secondary_pumping_depth: null
      };
      this.service.getMethods().then((function(_this) {
        return function(response) {
          return _this.scope.irrigation_methods = response.data.data;
        };
      })(this));
      this.service.getSources().then((function(_this) {
        return function(response) {
          return _this.scope.energy_sources = response.data;
        };
      })(this));
      this.service.getWaterSources().then((function(_this) {
        return function(response) {
          _this.scope.water_sources = response.data;
          return _this.scope.secondaryIrrigationWaterSourceId = _this.scope.water_sources.find(function(source) {
            return source.name === "Both Surface Water and Deep Aquifer Groundwater";
          }).id;
        };
      })(this));
      this.service.load(this.scope.details.layers_management_zone_id).then((function(_this) {
        return function(response) {
          if (response.data.data) {
            _this.scope.details = response.data.data;
          }
          return _this.setLoadedEnergySource();
        };
      })(this));
    }

    IrrigationDetailsController.prototype.copy = function() {
      this.scope.copyDisabled = true;
      return this.service.save(this.scope.details).then((function(_this) {
        return function(response) {
          return _this.ngModal.openCopyIrrigationDetailsDialog(parseInt(_this.transition$.params().field_id), parseInt(_this.transition$.params().year), _this.scope.details).modalRef.result["finally"](function() {
            return _this.scope.copyDisabled = false;
          });
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          _this.scope.copyDisabled = false;
          if (response.status === 422) {
            return _this.q.reject(response);
          }
        };
      })(this));
    };

    IrrigationDetailsController.prototype.save = function(pretending) {
      if (pretending == null) {
        pretending = false;
      }
      return this.service.save(this.scope.details).then((function(_this) {
        return function(response) {
          if (!pretending) {
            return _this.closeWithAlert({
              type: 'success',
              msg: 'Irrigation details saved'
            }, _this.scope.details, 2000);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          if (response.status === 422) {
            return _this.q.reject(response);
          }
        };
      })(this));
    };

    return IrrigationDetailsController;

  })(IrrigationDetailsBase);

}).call(this);
